import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireBirth = false }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-ink-muted">
                <div className="sp-overline">Loading</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (requireBirth && user?.needs_birth_data) return <Navigate to="/onboarding" replace />;
    return children;
}
